import { useDispatch } from 'react-redux';
import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';

import { companyRealtorModels, setCompanyRealtorTotalItems } from '..';

export function useCompanyRealtors() {
  const dispatch = useDispatch();
  const initial = {
    realtors: []
  };

  const [query] = useQueryParams({
    search: StringParam,
    page: withDefault(NumberParam, 1),
    size: withDefault(NumberParam, 10)
  });

  const { data = initial, ...arg } = useQuery<{
    realtors: companyRealtorModels.CompanyRealtorType[];
  }>(['company-realtors', query], async () => {
    const { data } = await $api.post('/v1/company/realtor/filter', query);

    dispatch(
      setCompanyRealtorTotalItems({
        totalElements: data?.data?.totalElements || 0,
        totalPages: data?.data?.totalPages || 0
      })
    );

    return { realtors: data?.data?.data };
  });

  return { ...data, ...arg };
}
